import {IBizRaffle, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {computed, ComputedRef, h} from "vue";
import {TrophyFilled} from "@ant-design/icons-vue";
import {IBusinessCustomSettingItem} from "@/views/editor/service/types";
import {ARaffle} from "@/views/editor/service/raffle/raffle";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export default class Raffle extends ARaffle implements IBizRaffle {
    subs: CheckboxOptionType[] = [];

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    resetMeta(): IBusiness {
        return this;
    }

    customSetting(): ComputedRef<IBusinessCustomSettingItem> | null {
        return computed(() => ({
            icon: () => h(TrophyFilled, {style: 'color:#eab308'}),
            kind: this.meta.kind,
            title: '抽奖',
            description: '不仅是高效的“流量磁石”，更是低成本获取大量用户信息和品牌曝光的利器。',
            enabled: this.meta.enabled,
            change: (b: boolean) => {
                this.meta.enabled = b;
            },
            checks: [],
            radios: {
                value: '', radios: [], change: () => {
                    //
                }
            },
        }))
    }

    setPrizes(owner: string, prizes: unknown[]): void {
        //
    }

}